import { useTranslation } from 'react-i18next';
import styles from './Login.module.scss';
import { Footer } from '../../common/Footer/Footer';
import { Header } from '../../common/Header/Header';
import defaultContent from '../../../content/login';
import useLogin from '../../CustomHooks/useLogin';
import { useEffect } from 'react';
import authService from '../../../config/auth.service';
import { useNavigate } from 'react-router';

const Login = (_props: any) => {
  const { onButtonClick, isLoading, isError } = useLogin();

  const { t } = useTranslation(['header']);
  const navigate = useNavigate();

  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/dashboard');
    }
  }, [navigate]);

  return (
    <div>
      <Header showNavigation={false} />
      <div className={styles['container']}>
        <div className={styles['login-container-body']}>
          <div className={styles['login-container']}>
            <p className={styles['login-text']}>{`${t(
              'loginText',
              defaultContent['loginText'],
            )}`}</p>
            <button className={styles['login-button']} onClick={onButtonClick}>
              {`${t('login', defaultContent['login'])}`}{' '}
            </button>
          </div>
        </div>
      </div>
      {isError && (
        <div>{`${t('something_went_wrong', defaultContent['something_went_wrong'])}`}</div>
      )}
      <Footer />
    </div>
  );
};

export default Login;
